import './stylesheets/design-system.css';
import './application.css';

import 'htmx.org';
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import { liteClient as algoliasearch } from "algoliasearch/lite";
import instantsearch from 'instantsearch.js';
import { hits, configure } from 'instantsearch.js/es/widgets';
import { connectSearchBox } from 'instantsearch.js/es/connectors';

Alpine.plugin(intersect);

// init htmx
window.htmx = require('htmx.org');

// init alpine
window.Alpine = Alpine;

Alpine.start();

// Search component
//
// note any styles used here may need to be added to tailwind config if they're not used elsewhere, as they may be
// removed when tailwind optimised the final css build
document.addEventListener('DOMContentLoaded', function () {
    let domNode = document.querySelector('#primary-search-results');
    if (domNode == null) {
        return; // blank layout doesn't have generic search box
    }
    const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
    let userInteracted = false;
    
    const searchClientWithEmptyQuery = {
        ...searchClient,
        search(requests) {
            if (requests.every(({ params }) => !params.query) && !userInteracted) {
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        nbPages: 0,
                        page: 0,
                        processingTimeMS: 0,
                    })),
                });
            }
            return searchClient.search(requests);
        },
    };

    const search = instantsearch({
        indexName: ALGOLIA_INDEX_NAME,
        searchClient: searchClientWithEmptyQuery,
    });

    var highlightedIndex = -1;

    function updateHighlight(hits, index) {
        hits.forEach(function(hit) { hit.classList.remove('bg-slate-100'); });
        if (index >= 0 && index < hits.length) {
            hits[index].classList.add('bg-slate-100');
            hits[index].scrollIntoView({ block: 'nearest' });
        }
    }

    var renderSearchBox = function(renderOptions, isFirstRender) {
        var query = renderOptions.query;
        var refine = renderOptions.refine;
        var clear = renderOptions.clear;
        var isSearchStalled = renderOptions.isSearchStalled;
        var widgetParams = renderOptions.widgetParams;

        var input = document.querySelector('#primary-search-input');

        if (isFirstRender) {
            input.addEventListener('focus', event => {
                if (!userInteracted) {
                    userInteracted = true;
                    refine(''); // Trigger search with empty query
                }
            });
            input.addEventListener('input', event => {
                refine(event.target.value);
            });
            input.addEventListener('keydown', function(event) {
                var results = document.querySelector('#primary-search-results');
                if (!results) return;
                var hits = Array.from(results.querySelectorAll('a[role="menuitem"]'));
                if (hits.length === 0) return;

                if (event.key === 'ArrowDown') {
                    event.preventDefault();
                    highlightedIndex = Math.min(highlightedIndex + 1, hits.length - 1);
                    updateHighlight(hits, highlightedIndex);
                } else if (event.key === 'ArrowUp') {
                    event.preventDefault();
                    highlightedIndex = Math.max(highlightedIndex - 1, -1);
                    updateHighlight(hits, highlightedIndex);
                } else if (event.key === 'Enter') {
                    if (highlightedIndex >= 0 && highlightedIndex < hits.length) {
                        event.preventDefault();
                        window.location = hits[highlightedIndex].href;
                    }
                }
            });

            var resultsContainer = document.querySelector('#primary-search-results');
            if (resultsContainer) {
                var searchObserver = new MutationObserver(function() {
                    highlightedIndex = -1;
                });
                searchObserver.observe(resultsContainer, { childList: true, subtree: true });
            }
        }
    }

    var customSearchBox = connectSearchBox(renderSearchBox);

    search.addWidgets([
        customSearchBox({}),
        configure({hitsPerPage: 10}),
        hits({
            container: '#primary-search-results',
            templates: {
                item(hit, { html, components }) {
                    var classes = "block px-4 py-2 text-sm hover:bg-slate-100 hover:text-gray-700";
                    if (!hit.active) {
                        classes = "block px-4 py-2 text-sm hover:text-gray-700 text-gray-400 bg-gray-50";
                    }
                    return html`<a
                            href="/s/${hit.slug}"
                            class="${classes}"
                            role="menuitem"
                          >
                            ${components.Highlight({ hit, attribute: 'name' })}
                          </a>`;
                },
                empty(results, { html }) {
                    if (!results.query) {
                        return html`<p class="block px-4 py-2 text-sm text-gray-500">Start typing to search company names and tickers</p>`;
                    }
                    return html`<p class="block px-4 py-2 text-sm text-gray-500">We couldn't find any stocks for <strong>${results.query}</strong> — did you try the full name?</p>`;
                }
            }
        }),
    ]);

    search.start();
});

/**
 * Onboarding stuff...
 *
 * note keeping this in this 1 file for now as I guess separating it would require another big js (compiled)
 * js file that has duplicate deps in it (algolia etc).
 *
 * So unless we want to split up more, might as well keep simple for now.
 *
 * Note: when adding new js files to the project, recreate the web container if it's not getting picked up.
 */
document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('#onboarding-search-results') == null) {
        // onboarding component not present
        return;
    }
    const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);

    const search = instantsearch({
        indexName: ALGOLIA_INDEX_NAME,
        searchClient
    });

    var renderSearchBox = function (renderOptions, isFirstRender) {
        // TODO

        var query = renderOptions.query;
        var refine = renderOptions.refine;
        var clear = renderOptions.clear;
        var isSearchStalled = renderOptions.isSearchStalled;
        var widgetParams = renderOptions.widgetParams;

        var input = document.querySelector('#onboarding-search');

        if (isFirstRender) {
            input.addEventListener('input', event => {
                refine(event.target.value);
            });
        }
    }

    var customSearchBox = connectSearchBox(renderSearchBox);

    search.addWidgets([
        customSearchBox({}),
        configure({hitsPerPage: 5}),
        hits({
            container: '#onboarding-search-results',
            templates: {
                item(hit, { html, components }) {
                    var classes = "block px-4 py-2 text-sm hover:bg-slate-100 hover:text-gray-700";
                    if (!hit.active) {
                        classes = "block px-4 py-2 text-sm hover:text-gray-700 text-gray-400 bg-gray-50";
                    }

                    return html`<button
                            hx-patch="/onboarding_sessions"
                            hx-trigger="click"
                            hx-target="#picked-stocks"
                            hx-vals='{"slug": "${hit.slug}"}'
                            x-on:click="search_open = false"
                            class="${classes} w-full flex justify-between items-center"
                            role="menuitem"
                          >
                            ${components.Highlight({ hit, attribute: 'name' })}
                            <div class="text-blue-500">Add</div>
                          </button>`;
                },
                empty: `<p class="block p-2 rounded text-sm bg-yellow-100 text-yellow-800">We couldn't find any stocks for <span class="font-bold">{{ query }}</span></p>`
            },
            cssClasses: {
                item: ['inline-block w-full']
            }
        }),
    ]);

    search.start();
});

/*
 * This is required because when Algolia changes the DOM, htmx isn't listening on new nodes
 * for trigger events.
 */
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('#onboarding-search-results') == null) {
        // onboarding component not present
        return;
    }
    const observer = new MutationObserver(function() {
        htmx.process(document.querySelector('#onboarding-search-results'));
    });

    observer.observe(document.querySelector('#onboarding-search-results'), { attributes: false, childList: true, characterData: false, subtree: true})
});

/*
 * Append an AssetRoom attribution line (with the post's canonical URL) whenever a reader copies
 * text from a post summary. Both text/plain and text/html are set so plain-text and rich-text
 * paste targets each get a usable link back to the post.
 */
document.addEventListener('DOMContentLoaded', function () {
    var postContents = document.querySelectorAll('.post-content');
    if (postContents.length === 0) {
        return; // not a post page
    }

    var canonical = document.querySelector('link[rel="canonical"]');
    var postUrl = canonical ? canonical.href : window.location.href;
    var promoText = '\n\nRead the full AI-powered summary on AssetRoom: ' + postUrl;
    var promoHtml = '<p>Read the full AI-powered summary on AssetRoom: ' +
        '<a href="' + postUrl + '">' + postUrl + '</a></p>';

    postContents.forEach(function (el) {
        el.addEventListener('copy', function (event) {
            var selection = document.getSelection();
            if (!selection || selection.toString().length === 0) {
                return; // nothing selected, let the default copy proceed
            }
            if (!event.clipboardData) {
                return; // no clipboard access, let the browser's default copy proceed
            }

            var container = document.createElement('div');
            for (var i = 0; i < selection.rangeCount; i++) {
                container.appendChild(selection.getRangeAt(i).cloneContents());
            }

            event.clipboardData.setData('text/plain', selection.toString() + promoText);
            event.clipboardData.setData('text/html', container.innerHTML + promoHtml);
            event.preventDefault();
        });
    });
});